(function() {
    // basic definitions
    window.c24Lp = window.c24Lp || {};
    window.c24 = window.c24 || {
        lp: {
            ac: {},
        },
    };

    // frame-js-ready callback
    if (window.c24LpFrameJsReady === undefined) {
        window.c24LpFrameJsReady = new Promise((resolve) => {
            window.c24LpInternalFrameJsIsReady = () => resolve(true);
        });
    }

    // css-ready callback
    if (window.c24LpCssLoaded === undefined) {
        window.c24LpCssLoaded = new Promise((resolve) => {
            window.c24LpInternalCssIsLoaded = () => resolve(true);
        });
    }

    const chechForCssLoaded = () => {
        const styleLinks = document.querySelectorAll('link[as=style]');
        const styleLinksLoaded = Array.from(styleLinks).filter(function(e) { return e.rel === 'stylesheet';});

        if ($('.c24FrameLoaded').css('display') === 'none' && styleLinks.length === styleLinksLoaded.length) {
            window.c24LpInternalCssIsLoaded();
        } else {
            setTimeout(chechForCssLoaded, 70);
        }
    };
    setTimeout(chechForCssLoaded, 70);

    // ready events
    window.c24DomReady = (callBack) => {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callBack);
        }
        else {
            callBack();
        }
    };

    window.c24DOMContentLoadedReplacement = (_, callback) => {
        window.c24DomReady(callback);
    };

    window.c24WindowReady = (callBack) => {
        if (document.readyState === 'complete') {
            callBack();
        }
        else {
            window.addEventListener('load', callBack);
        }
    };

    window.c24WindowLoadReplacement = (_, callback) => {
        window.c24WindowReady(callback);
    };
})();
